import { Component, OnInit } from '@angular/core';
import { Contenido } from 'src/app/models/Contenido';
import { ActivatedRoute, Router } from '@angular/router';
import { ContenidosapiService } from 'src/app/services/contenidosapi.service';
import { LoadingState } from '../../../redux/reducers/loading.reducer';
import { Store } from '@ngrx/store';
import { showLoading, hideLoading } from '../../../redux/actions/loading.actions';
import { Autoformat, AutoImage, Autosave, BlockQuote, Bold, ClassicEditor, Code, Emoji, Essentials, Heading, ImageBlock, ImageCaption, ImageInline, ImageInsert, ImageInsertViaUrl, ImageResize, ImageStyle, ImageTextAlternative, ImageToolbar, ImageUpload, Indent, IndentBlock, Italic, Link, LinkImage, List, ListProperties, MediaEmbed, Mention, Paragraph, PasteFromOffice, PictureEditing, RedoCommand, Strikethrough, Subscript, Superscript, Table, TableCaption, TableCellProperties, TableColumnResize, TableProperties, TableToolbar, TextTransformation, TodoList, Underline, Undo } from 'ckeditor5';
@Component({
  selector: 'app-formcontenidos',
  templateUrl: './formcontenidos.component.html',
  styleUrls: ['./formcontenidos.component.scss'],
  standalone: false
})
export class FormcontenidosComponent implements OnInit {
  contenido: Contenido = { id: 0, key: '', value: '', tipoContenido: 0 };
  error: boolean;
  public Editor = ClassicEditor;
  public config = {
    licenseKey: 'GPL',
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'indent',
        'outdent',
        '|',

        'insertImage',
        'blockQuote',

        'mediaEmbed',
        'insertTable',
        'undo',
        'redo',

      ],
      shouldNotGroupWhenFull: false
    },
    plugins: [
      Autoformat,
      AutoImage,
      Autosave,
      BlockQuote,
      Bold,
      Essentials,
      Heading,
      ImageBlock,
      ImageCaption,
      ImageInline,
      ImageInsert,
      ImageInsertViaUrl,
      ImageResize,
      ImageStyle,
      ImageTextAlternative,
      ImageToolbar,
      ImageUpload,
      Indent,
      IndentBlock,
      Italic,
      Link,
      LinkImage,
      List,
      ListProperties,
      MediaEmbed,
      Mention,
      Paragraph,
      PasteFromOffice,
      PictureEditing,
      Table,
      TableCaption,
      TableCellProperties,
      TableColumnResize,
      TableProperties,
      TableToolbar,
      TextTransformation,
      Undo
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3'
        },
        {
          model: 'heading4',
          view: 'h4',
          title: 'Heading 4',
          class: 'ck-heading_heading4'
        },
        {
          model: 'heading5',
          view: 'h5',
          title: 'Heading 5',
          class: 'ck-heading_heading5'
        },
        {
          model: 'heading6',
          view: 'h6',
          title: 'Heading 6',
          class: 'ck-heading_heading6'
        }
      ]
    },
    image: {
      toolbar: [
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'imageStyle:inline',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'resizeImage',
        '|'
      ]
    },
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    mention: {
      feeds: [
        {
          marker: '@',
          feed: [
            /* See: https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html */
          ]
        }
      ]
    },
    placeholder: 'Escribir contenido...',
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
    },
  }
  constructor(
    private actRoute: ActivatedRoute,
    private api: ContenidosapiService,
    private router: Router,
    private storeLoading: Store<LoadingState>
  ) {
    this.actRoute.params.subscribe(data => {
      // console.log(data);
      if (data.id) {
        // console.log(data.id);
        this.getContenido(data.id);
      } else {
        // this.fechaNacimientoObject = this.parserFormatter.parse(this.Contenido.fechaNacimiento);
      }
    });
  }

  getContenido(id: string) {
    this.storeLoading.dispatch(showLoading({ loadingText: "Obteniendo datos del contenido..." }));

    this.api.getContenido(id).subscribe(data => {
      if (data) {
        const newDoc: Contenido = {
          id: data.id,
          key: data.key,
          value: data.value,
          tipoContenido: 0
        };
        // console.log(newDoc);
        this.contenido = newDoc;
        this.error = false;
      } else {
        this.error = true;
      }
      // console.log(data);

      this.storeLoading.dispatch(hideLoading());
    });
  }

  ngOnInit() {
  }
  guardarDatos() {
    this.storeLoading.dispatch(showLoading({ loadingText: "Guardando datos..." }));

    // console.log(this.contenido);
    if (this.contenido.id === 0) {
      this.api.createContenido(this.contenido).subscribe(listaContenidos => {
        this.storeLoading.dispatch(hideLoading());
        this.router.navigateByUrl('/contenidos');
      }, (error) => {
        this.storeLoading.dispatch(hideLoading());
      });
    } else {
      this.api.updateContenido(this.contenido).subscribe(listaContenidos => {
        this.storeLoading.dispatch(hideLoading());
        this.router.navigateByUrl('/contenidos');
      }, (error) => {
        console.log(error);
        this.storeLoading.dispatch(hideLoading());
      });
    }
  }

}
